import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  ListItemText,
  MenuItem,
  Typography
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import { i18nToast } from '../../helpers/i18nToast'
import api from '../../services/api'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import { InputFieldText } from '../InputFieldText'
import { InputSwitch } from '../InputSwitch'
import SelectInput from '../SelectInput'
import { useStyles } from './style'

const cloneWorkSchedule = schedule => JSON.parse(JSON.stringify(schedule))

const defaultUserWorkSchedule = {
  enabled: false,
  overtimeLimit: '15',
  days: {
    0: {
      enabled: false,
      start: '08:00',
      end: '18:00',
      lunchStart: '12:00',
      lunchEnd: '13:00'
    },
    1: {
      enabled: true,
      start: '08:00',
      end: '18:00',
      lunchStart: '12:00',
      lunchEnd: '13:00'
    },
    2: {
      enabled: true,
      start: '08:00',
      end: '18:00',
      lunchStart: '12:00',
      lunchEnd: '13:00'
    },
    3: {
      enabled: true,
      start: '08:00',
      end: '18:00',
      lunchStart: '12:00',
      lunchEnd: '13:00'
    },
    4: {
      enabled: true,
      start: '08:00',
      end: '18:00',
      lunchStart: '12:00',
      lunchEnd: '13:00'
    },
    5: {
      enabled: true,
      start: '08:00',
      end: '18:00',
      lunchStart: '12:00',
      lunchEnd: '13:00'
    },
    6: {
      enabled: false,
      start: '08:00',
      end: '18:00',
      lunchStart: '12:00',
      lunchEnd: '13:00'
    }
  }
}

const DepartmentUserScheduleModal = ({ open, onClose, scheduleId, onSave }) => {
  const classes = useStyles()

  const [queues, setQueues] = useState([])
  const [allUsers, setAllUsers] = useState([])
  const [selectedQueueId, setSelectedQueueId] = useState('')
  const [queueUsers, setQueueUsers] = useState([])
  const [selectedUserIds, setSelectedUserIds] = useState([])
  const [applyLoading, setApplyLoading] = useState(false)

  // Estados de Almoço Separados
  const [lunchWeekEnabled, setLunchWeekEnabled] = useState(false)
  const [lunchSatEnabled, setLunchSatEnabled] = useState(false)
  const [lunchSunEnabled, setLunchSunEnabled] = useState(false)

  // Estados de CRUD
  const [, setSavedSchedules] = useState([])
  const [savedScheduleName, setSavedScheduleName] = useState('')
  const [, setSelectedSavedScheduleId] = useState('')

  const [workSchedule, setWorkSchedule] = useState(
    cloneWorkSchedule(defaultUserWorkSchedule)
  )

  const weekDaysUser = [
    { key: '1', label: 'Seg' },
    { key: '2', label: 'Ter' },
    { key: '3', label: 'Qua' },
    { key: '4', label: 'Qui' },
    { key: '5', label: 'Sex' },
    { key: '6', label: 'Sáb' },
    { key: '0', label: 'Dom' }
  ]

  const fetchSavedSchedules = async () => {
    try {
      const { data } = await api.get('/users/work-schedule-templates')
      setSavedSchedules(Array.isArray(data) ? data : [])
    } catch {
      i18nToast.error('Não foi possível buscar os horários salvos.')
    }
  }

  useEffect(() => {
    if (!open) return

    if (scheduleId) {
      const loadSchedule = async () => {
        try {
          const { data } = await api.get(
            `/users/work-schedule-templates/${scheduleId}`
          )
          const { workSchedule: ws, name } = data

          setWorkSchedule(cloneWorkSchedule(ws))
          setSavedScheduleName(name)
          setSelectedSavedScheduleId(data.id)

          setLunchWeekEnabled(
            !!(ws.days?.[1]?.lunchStart || ws.days?.[2]?.lunchStart)
          )
          setLunchSatEnabled(!!ws.days?.[6]?.lunchStart)
          setLunchSunEnabled(!!ws.days?.[0]?.lunchStart)
        } catch (err) {
          i18nToast.error('Erro ao carregar dados do turno.')
          onClose()
        }
      }
      loadSchedule()
    } else {
      setWorkSchedule(cloneWorkSchedule(defaultUserWorkSchedule))
      setSavedScheduleName('')
      setSelectedSavedScheduleId('')
      setLunchWeekEnabled(false)
      setLunchSatEnabled(false)
      setLunchSunEnabled(false)
      setSelectedQueueId('')
      setSelectedUserIds([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, scheduleId])

  useEffect(() => {
    const fetchQueues = async () => {
      try {
        const { data } = await api.get('/queue')
        setQueues(
          data.filter(q => q.isBot === false && q.notificationact === false)
        )
      } catch {
        i18nToast.error('Não foi possível buscar os departamentos.')
      }
    }
    if (open) fetchQueues()
  }, [open])

  useEffect(() => {
    if (open) {
      fetchSavedSchedules()
    }
  }, [open])

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const { data } = await api.get('/users/list')
        setAllUsers(data)
      } catch {
        i18nToast.error('Não foi possível buscar os usuários.')
      }
    }
    if (open) fetchAllUsers()
  }, [open])

  useEffect(() => {
    if (!selectedQueueId) {
      setQueueUsers([])
      setSelectedUserIds([])
      return
    }
    const fetchUsers = async () => {
      try {
        const { data } = await api.get(`/users/queue/${selectedQueueId}`)
        setQueueUsers(data)
        setSelectedUserIds(data.map(user => Number(user.id)))
      } catch {
        i18nToast.error('Não foi possível buscar os usuários do departamento.')
      }
    }
    fetchUsers()
  }, [selectedQueueId])

  const queueUserIds = queueUsers.map(user => Number(user.id))

  const showWeekTime = [1, 2, 3, 4, 5].some(
    day => workSchedule.days[day]?.enabled
  )
  const showSaturdayTime = !!workSchedule.days[6]?.enabled
  const showSundayTime = !!workSchedule.days[0]?.enabled

  const handleDayToggle = (dayKey, enabled) => {
    setWorkSchedule(prev => {
      const nextDays = {
        ...prev.days,
        [dayKey]: { ...prev.days[dayKey], enabled }
      }
      return { ...prev, days: nextDays }
    })
  }

  const handleTimeChange = (dayKey, field, value) => {
    setWorkSchedule(prev => ({
      ...prev,
      days: {
        ...prev.days,
        [dayKey]: { ...prev.days[dayKey], [field]: value }
      }
    }))
  }

  const handleWeekTimeChange = (field, value) => {
    setWorkSchedule(prev => {
      const nextDays = { ...prev.days }
      ;[1, 2, 3, 4, 5].forEach(day => {
        if (nextDays[day].enabled) {
          nextDays[day][field] = value
        }
      })
      return { ...prev, days: nextDays }
    })
  }

  const handleUsersChange = event => {
    const selectedIds = (event.target.value || []).map(id => Number(id))
    const mergedIds = Array.from(new Set([...queueUserIds, ...selectedIds]))
    setSelectedUserIds(mergedIds)
  }

  // const handleSelectSavedSchedule = event => {
  //   const selectedId = event.target.value
  //   setSelectedSavedScheduleId(selectedId)

  //   if (selectedId === '') {
  //     setWorkSchedule(cloneWorkSchedule(defaultUserWorkSchedule))
  //     setSavedScheduleName('')
  //     setLunchWeekEnabled(false)
  //     setLunchSatEnabled(false)
  //     setLunchSunEnabled(false)
  //     return
  //   }

  //   const selectedSchedule = savedSchedules.find(
  //     schedule => String(schedule.id) === String(selectedId)
  //   )

  //   if (selectedSchedule?.workSchedule) {
  //     setWorkSchedule(cloneWorkSchedule(selectedSchedule.workSchedule))
  //     setSavedScheduleName(selectedSchedule.name)

  //     setLunchWeekEnabled(!!selectedSchedule.workSchedule.days?.[1]?.lunchStart)
  //     setLunchSatEnabled(!!selectedSchedule.workSchedule.days?.[6]?.lunchStart)
  //     setLunchSunEnabled(!!selectedSchedule.workSchedule.days?.[0]?.lunchStart)
  //   }
  // }

  // const handleSaveCurrentSchedule = async () => {
  //   const trimmedName = savedScheduleName.trim()
  //   if (!trimmedName) {
  //     i18nToast.error('Informe um nome para salvar o horário.')
  //     return
  //   }

  //   const scheduleToSave = cloneWorkSchedule(workSchedule)
  //   // Limpa almoço dos dias caso as opções visuais estejam desligadas
  //   ;[1, 2, 3, 4, 5].forEach(d => {
  //     if (!lunchWeekEnabled) {
  //       scheduleToSave.days[d].lunchStart = ''
  //       scheduleToSave.days[d].lunchEnd = ''
  //     }
  //   })
  //   if (!lunchSatEnabled) {
  //     scheduleToSave.days[6].lunchStart = ''
  //     scheduleToSave.days[6].lunchEnd = ''
  //   }
  //   if (!lunchSunEnabled) {
  //     scheduleToSave.days[0].lunchStart = ''
  //     scheduleToSave.days[0].lunchEnd = ''
  //   }

  //   try {
  //     const templateId = selectedSavedScheduleId || scheduleId
  //     let data

  //     if (templateId) {
  //       const response = await api.put(
  //         `/users/work-schedule-templates/${templateId}`,
  //         {
  //           name: trimmedName,
  //           workSchedule: scheduleToSave
  //         }
  //       )
  //       data = response.data
  //     } else {
  //       const response = await api.post('/users/work-schedule-templates', {
  //         name: trimmedName,
  //         workSchedule: scheduleToSave
  //       })
  //       data = response.data
  //     }

  //     const nextSchedules = [
  //       ...savedSchedules.filter(
  //         schedule => String(schedule.id) !== String(data.id)
  //       ),
  //       data
  //     ].sort((a, b) => a.name.localeCompare(b.name))

  //     setSavedSchedules(nextSchedules)
  //     setSelectedSavedScheduleId(data.id)
  //     setSavedScheduleName(data.name)

  //     if (typeof onSave === 'function') {
  //       onSave()
  //     }

  //     i18nToast.success(
  //       templateId
  //         ? 'Horário atualizado com sucesso!'
  //         : 'Horário salvo com sucesso!'
  //     )
  //   } catch {
  //     i18nToast.error('Não foi possível salvar o horário.')
  //   }
  // }

  const handleApply = async () => {
    const trimmedName = savedScheduleName.trim()

    if (!trimmedName) {
      i18nToast.error('Informe um nome para o perfil.')
      return
    }

    setApplyLoading(true)

    const finalSchedule = cloneWorkSchedule(workSchedule)

    finalSchedule.allowOvertime = !!finalSchedule.enabled
    finalSchedule.enabled = !!finalSchedule.enabled

    const sanitizeLunch = (dayKeys, isSwitchEnabled) => {
      dayKeys.forEach(d => {
        const day = finalSchedule.days[d]
        if (!isSwitchEnabled || !day.enabled) {
          day.lunchStart = ''
          day.lunchEnd = ''
        } else {
          day.lunchStart = day.lunchStart || ''
          day.lunchEnd = day.lunchEnd || ''
        }
      })
    }

    sanitizeLunch([1, 2, 3, 4, 5], lunchWeekEnabled)
    sanitizeLunch([6], lunchSatEnabled)
    sanitizeLunch([0], lunchSunEnabled)

    try {
      const payload = {
        name: trimmedName,
        workSchedule: finalSchedule
      }

      if (scheduleId) {
        await api.put(`/users/work-schedule-templates/${scheduleId}`, payload)
      } else {
        await api.post('/users/work-schedule-templates', payload)
      }

      if (selectedQueueId && selectedUserIds.length > 0) {
        const { data } = await api.put(
          `/users/queue/${selectedQueueId}/work-schedule`,
          {
            workSchedule: finalSchedule,
            userIds: selectedUserIds
          }
        )
      }

      i18nToast.success('Configurações salvas com sucesso!')

      onClose()
      if (typeof onSave === 'function') onSave()
    } catch (err) {
      i18nToast.error('Erro ao salvar e aplicar as configurações.')
    } finally {
      setApplyLoading(false)
    }
  }

  const renderUsersValue = selected => {
    if (!selected || selected.length === 0) return 'Nenhum usuário selecionado'
    const selectedNames = allUsers
      .filter(user => selected.includes(Number(user.id)))
      .map(user => user.name)
    if (selectedNames.length <= 2) return selectedNames.join(', ')
    return `${selectedNames.length} usuários selecionados`
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className={classes.dialogTitle}>
        {scheduleId
          ? `Editando: ${savedScheduleName}`
          : 'Novo Expediente de Usuários'}
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2} className={classes.container}>
          <Grid container item xs={12} spacing={1} alignItems="center">
            <Grid item xs={12}>
              <InputFieldText
                label="Nome do Perfil"
                fullWidth
                value={savedScheduleName}
                onChange={e => setSavedScheduleName(e.target.value)}
                placeholder="Exemplo: Turno Equipe A"
                variant="outlined"
                size="small"
              />
            </Grid>
            {/* <Grid item xs={12} sm={5}>
              <SelectInput
                label="Carregar Perfil Salvo"
                value={selectedSavedScheduleId}
                onChange={handleSelectSavedSchedule}
                fullWidth
              >
                <MenuItem value="">Selecione</MenuItem>
                {savedSchedules.map(schedule => (
                  <MenuItem key={schedule.id} value={schedule.id}>
                    {schedule.name}
                  </MenuItem>
                ))}
              </SelectInput>
            </Grid>
            <Grid item xs={12} sm={2} style={{ marginTop: '22px' }}>
              <ButtonSecondary
                label={
                  selectedSavedScheduleId || scheduleId
                    ? 'Atualizar Perfil'
                    : 'Salvar Perfil'
                }
                onClick={handleSaveCurrentSchedule}
              />
            </Grid> */}
          </Grid>

          {/* SELEÇÃO DE DIAS (Seg, Ter, Qua...) */}
          <Grid
            item
            xs={12}
            className={classes.contentWeekDays}
            style={{ marginTop: 10 }}
          >
            <FormControl component="fieldset">
              <FormLabel component="legend" className={classes.formLabel}>
                Selecione os dias em que o usuário pode trabalhar
              </FormLabel>
              <FormGroup row>
                {weekDaysUser.map(day => (
                  <FormControlLabel
                    key={day.key}
                    className={classes.label}
                    control={
                      <Checkbox
                        checked={workSchedule.days[day.key]?.enabled || false}
                        onChange={e =>
                          handleDayToggle(day.key, e.target.checked)
                        }
                        color="primary"
                      />
                    }
                    label={day.label}
                  />
                ))}
              </FormGroup>
            </FormControl>
          </Grid>

          {/* BLOCO: SEMANA */}
          {showWeekTime && (
            <Grid item xs={12} className={classes.contentTime}>
              <FormControl className={classes.formControl}>
                <FormLabel component="legend" className={classes.formLabel}>
                  Horário durante a semana
                </FormLabel>
                <div className={classes.inputWrapper}>
                  <InputFieldText
                    label="Entrada"
                    type="time"
                    value={workSchedule.days[1]?.start || '08:00'}
                    onChange={e =>
                      handleWeekTimeChange('start', e.target.value)
                    }
                    fullWidth
                  />
                  <Typography className={classes.textUntil}>até</Typography>
                  <InputFieldText
                    label="Saída"
                    type="time"
                    value={workSchedule.days[1]?.end || '18:00'}
                    onChange={e => handleWeekTimeChange('end', e.target.value)}
                    fullWidth
                  />
                </div>
              </FormControl>

              <FormControl className={classes.formControl}>
                <div
                  className={`${classes.switchContainer} ${lunchWeekEnabled ? classes.switchContainerActive : ''}`}
                >
                  <InputSwitch
                    label="Adicionar Intervalo"
                    size="small"
                    checked={lunchWeekEnabled}
                    onChange={e => setLunchWeekEnabled(e.target.checked)}
                  />
                </div>
                {lunchWeekEnabled && (
                  <div className={classes.inputWrapper}>
                    <InputFieldText
                      type="time"
                      label="Início"
                      value={workSchedule.days[1]?.lunchStart || '12:00'}
                      onChange={e =>
                        handleWeekTimeChange('lunchStart', e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                    <Typography className={classes.textUntil}>até</Typography>
                    <InputFieldText
                      type="time"
                      label="Fim"
                      value={workSchedule.days[1]?.lunchEnd || '13:00'}
                      onChange={e =>
                        handleWeekTimeChange('lunchEnd', e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                )}
              </FormControl>
            </Grid>
          )}

          {showSaturdayTime && (
            <Grid item xs={12} className={classes.contentTime}>
              <FormControl className={classes.formControl}>
                <FormLabel component="legend" className={classes.formLabel}>
                  Sábado
                </FormLabel>
                <div className={classes.inputWrapper}>
                  <InputFieldText
                    label="Entrada"
                    type="time"
                    value={workSchedule.days[6]?.start || '08:00'}
                    onChange={e => handleTimeChange(6, 'start', e.target.value)}
                    fullWidth
                  />
                  <Typography className={classes.textUntil}>até</Typography>
                  <InputFieldText
                    label="Saída"
                    type="time"
                    value={workSchedule.days[6]?.end || '12:00'}
                    onChange={e => handleTimeChange(6, 'end', e.target.value)}
                    fullWidth
                  />
                </div>
              </FormControl>

              <FormControl className={classes.formControl}>
                <div
                  className={`${classes.switchContainer} ${lunchSatEnabled ? classes.switchContainerActive : ''}`}
                >
                  <InputSwitch
                    label="Adicionar Intervalo"
                    size="small"
                    checked={lunchSatEnabled}
                    onChange={e => setLunchSatEnabled(e.target.checked)}
                  />
                </div>
                {lunchSatEnabled && (
                  <div className={classes.inputWrapper}>
                    <InputFieldText
                      type="time"
                      label="Início"
                      value={workSchedule.days[6]?.lunchStart || '12:00'}
                      onChange={e =>
                        handleTimeChange(6, 'lunchStart', e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                    <Typography className={classes.textUntil}>até</Typography>
                    <InputFieldText
                      type="time"
                      label="Fim"
                      value={workSchedule.days[6]?.lunchEnd || '13:00'}
                      onChange={e =>
                        handleTimeChange(6, 'lunchEnd', e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                )}
              </FormControl>
            </Grid>
          )}

          {showSundayTime && (
            <Grid item xs={12} className={classes.contentTime}>
              <FormControl className={classes.formControl}>
                <FormLabel component="legend" className={classes.formLabel}>
                  Domingo
                </FormLabel>
                <div className={classes.inputWrapper}>
                  <InputFieldText
                    label="Entrada"
                    type="time"
                    value={workSchedule.days[0]?.start || '08:00'}
                    onChange={e => handleTimeChange(0, 'start', e.target.value)}
                    fullWidth
                  />
                  <Typography className={classes.textUntil}>até</Typography>
                  <InputFieldText
                    label="Saída"
                    type="time"
                    value={workSchedule.days[0]?.end || '12:00'}
                    onChange={e => handleTimeChange(0, 'end', e.target.value)}
                    fullWidth
                  />
                </div>
              </FormControl>

              <FormControl className={classes.formControl}>
                <div
                  className={`${classes.switchContainer} ${lunchSunEnabled ? classes.switchContainerActive : ''}`}
                >
                  <InputSwitch
                    label="Adicionar Intervalo"
                    size="small"
                    checked={lunchSunEnabled}
                    onChange={e => setLunchSunEnabled(e.target.checked)}
                  />
                </div>
                {lunchSunEnabled && (
                  <div className={classes.inputWrapper}>
                    <InputFieldText
                      type="time"
                      label="Início"
                      value={workSchedule.days[0]?.lunchStart || '12:00'}
                      onChange={e =>
                        handleTimeChange(0, 'lunchStart', e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                    <Typography className={classes.textUntil}>até</Typography>
                    <InputFieldText
                      type="time"
                      label="Fim"
                      value={workSchedule.days[0]?.lunchEnd || '13:00'}
                      onChange={e =>
                        handleTimeChange(0, 'lunchEnd', e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                )}
              </FormControl>
            </Grid>
          )}

          <Grid item className={classes.boxAttention}>
            <Typography className={classes.textAttention}>
              <strong>Atenção!</strong> Utilize Horário de Brasília
            </Typography>
          </Grid>

          <Grid item xs={12} className={classes.inputWrapper}>
            <Grid item xs={12} sm={6}>
              <SelectInput
                label="Departamento"
                value={selectedQueueId}
                onChange={e => setSelectedQueueId(e.target.value)}
                fullWidth
              >
                <MenuItem value="">Selecione</MenuItem>
                {queues.map(q => (
                  <MenuItem key={q.id} value={q.id}>
                    {q.name}
                  </MenuItem>
                ))}
              </SelectInput>
            </Grid>

            <Grid item xs={12} sm={6}>
              <SelectInput
                label="Usuários"
                multiple
                value={selectedUserIds}
                onChange={handleUsersChange}
                renderValue={renderUsersValue}
                disabled={!selectedQueueId}
                fullWidth
              >
                {allUsers.map(user => (
                  <MenuItem key={user.id} value={Number(user.id)}>
                    <Checkbox
                      checked={selectedUserIds.includes(Number(user.id))}
                    />
                    <ListItemText primary={user.name} />
                  </MenuItem>
                ))}
              </SelectInput>
            </Grid>
          </Grid>

          <Grid item xs={12} className={classes.inputSwitch}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item>
                <InputSwitch
                  label="Permitir Hora extra"
                  checked={workSchedule.enabled}
                  onChange={e => {
                    const isChecked = e.target.checked
                    setWorkSchedule(prev => ({
                      ...prev,
                      enabled: isChecked
                    }))
                  }}
                />
              </Grid>

              {workSchedule.enabled && (
                <Grid item xs={3} sm={2}>
                  <SelectInput
                    value={workSchedule.overtimeLimit || '15'}
                    onChange={e =>
                      setWorkSchedule(prev => ({
                        ...prev,
                        overtimeLimit: e.target.value
                      }))
                    }
                    size="small"
                    fullWidth
                  >
                    <MenuItem value="15">15m</MenuItem>
                    <MenuItem value="30">30m</MenuItem>
                    <MenuItem value="1h">1h</MenuItem>
                    <MenuItem value="2h">2h</MenuItem>
                  </SelectInput>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions style={{ padding: '16px 24px' }}>
        <ButtonSecondary label="CANCELAR" onClick={onClose} />
        <ButtonPrimary
          label="Salvar"
          loading={applyLoading}
          onClick={handleApply}
          disabled={!savedScheduleName.trim()}
        />
      </DialogActions>
    </Dialog>
  )
}

export default DepartmentUserScheduleModal
